import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'gradebook.page.title': {
    id: 'gradebook.page.title',
    defaultMessage: 'Gradebook | {siteName}',
    description: 'Title tag',
  },
});

export default messages;
